export default {
  // ...
};
